var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkEmailUnread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.309-180.001q-30.308 0-51.308-21t-21-51.308v-455.382q0-30.308 21-51.308t51.308-21h400.922q-2.846 15-3.038 29.807-.192 14.808 2.269 30.192H166.154L480-520l144.461-92.154q10.539 9.923 22.423 17.884 11.884 7.962 24.884 14.192L480-457.694 160-662.309v410q0 5.385 3.462 8.847 3.462 3.462 8.847 3.462h615.382q5.385 0 8.847-3.462 3.462-3.462 3.462-8.847V-559q17.23-3.846 32.038-10.153 14.807-6.308 27.961-15.461v332.305q0 30.308-21 51.308t-51.308 21H172.309ZM160-720V-240v-480Zm600 85.385q-45.769 0-77.884-32.115t-32.115-77.884q0-45.769 32.115-77.884 32.115-32.116 77.884-32.116t77.884 32.116q32.115 32.115 32.115 77.884t-32.115 77.884Q805.769-634.615 760-634.615Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkEmailUnread);
export default __webpack_public_path__ + "static/media/mark_email_unread.812da439cca10a804c7a287739b44882.svg";
export { ForwardRef as ReactComponent };